import React, { useEffect, useState } from 'react';
import { useAuth } from '../App';

const block = (e) => e.preventDefault();

// Wraps viewed content: stamps the viewer's email over it (so screenshots are traceable)
// and blocks right-click, dragging and text selection.
export function Watermark({ children }) {
  const { user } = useAuth();
  const stamp = `${user.email} · MK Classes`;
  return (
    <div className="protected" onContextMenu={block} onDragStart={block} onCopy={block}>
      {children}
      <div className="protected__mark" aria-hidden="true">
        {Array.from({ length: 24 }, (_, i) => <span key={i}>{stamp}</span>)}
      </div>
    </div>
  );
}

// Page-wide guard for the Study Hub: hides content while the page is not in focus
// (Snipping Tool, screen recorders, switching apps), on Print Screen, and blocks save/print shortcuts.
export function useScreenGuard(enabled) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!enabled) return undefined;
    let timer;
    const hide = () => setHidden(true);
    const show = () => setHidden(false);
    const flash = () => {
      setHidden(true);
      clearTimeout(timer);
      timer = setTimeout(() => setHidden(!document.hasFocus()), 1500);
    };
    const onKey = (e) => {
      const key = e.key.toLowerCase();
      if (e.key === 'PrintScreen') {
        flash();
        navigator.clipboard?.writeText('').catch(() => {});
      }
      if ((e.ctrlKey || e.metaKey) && ['s', 'p', 'u'].includes(key)) {
        e.preventDefault();
        flash();
      }
      if (e.metaKey && e.shiftKey) flash(); // macOS screenshot shortcuts
    };
    const onVisibility = () => (document.hidden ? hide() : show());

    window.addEventListener('blur', hide);
    window.addEventListener('focus', show);
    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('keydown', onKey);
    window.addEventListener('keyup', onKey);
    window.addEventListener('beforeprint', hide);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('blur', hide);
      window.removeEventListener('focus', show);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('keydown', onKey);
      window.removeEventListener('keyup', onKey);
      window.removeEventListener('beforeprint', hide);
    };
  }, [enabled]);

  return hidden;
}
